import { useState, useMemo, useEffect } from "react"
import keyBy from "lodash.keyby"

import api from "@api"
import { INVESTMENT_STATUS } from "@components/Domain/Constants"
import { processInvestments } from "@components/Domain/InvestmentForm/InvestmentForm"
import getFormattedDecimalValue from "@helpers/getFormattedDecimalValue"

export const indexInvestmentsOperation = api.get("investments/IndexMyInvestments")


const useInvestmentsStore = (request, shouldAutoLoad = true) => {
  const [ investments, setProcessedInvestments ] = useState()

  let isInProgress = false
  useEffect(() => {
    if (isInProgress) { return }
    isInProgress = true

    if (!shouldAutoLoad) {
      return
    }

    indexInvestments()
  }, [])

  const addInvestment = newItem =>
    setProcessedInvestments(prevItems =>
      processInvestments([ newItem, ...prevItems ])
    )

  const updateInvestment = updatedItem =>
    setProcessedInvestments((prevItems = []) =>
      processInvestments(
        prevItems.map(item => ({
          ...(item.id === updatedItem.id ? updatedItem : item)
        }))
      )
    )

  const deleteInvestment = id =>
    setProcessedInvestments(prevItems =>
      processInvestments(
        [...prevItems.filter(item => item.id !== id)]
      )
    )

  const setInvestments = data => {
    const processedInvestments = processInvestments(data)
    setProcessedInvestments(processedInvestments)
  }

  const indexInvestments = () =>
    request(indexInvestmentsOperation.id)
      .then(({ data }) => setInvestments(data))

  const getProjectInvestments = projectId =>
    investments
      .filter(investment => investment.projectId === projectId)
      .filter(({ status }) => status !== INVESTMENT_STATUS.REJECTED)

  const getProjectInvestedAmount = projectId =>
    getProjectInvestments(projectId)
      .map(({ investments: classes }) => classes
        .reduce((acc, investment) => getFormattedDecimalValue(acc, investment.amount, "plus"), 0)
      )
      .reduce((acc, amount) => getFormattedDecimalValue(acc, amount, "plus"), 0)

  const investmentsMap = useMemo(() =>
    keyBy(investments, "id")
  , [ investments ])

  return {
    investments,
    addInvestment,
    investmentsMap,
    updateInvestment,
    deleteInvestment,
    indexInvestments,
    getProjectInvestments,
    setProcessedInvestments,
    getProjectInvestedAmount,
  }
}

export default useInvestmentsStore
